import apiService from './apiService';

const packageService = {
  getPackagesByProvider: async (providerId) => {
    return apiService.get(`/packages/provider/${providerId}`);
  },

  getAllPackagesByProvider: async (providerId) => {
    return apiService.get(`/packages/provider/${providerId}/all`);
  },

  createPackage: async (providerId, data) => {
    return apiService.post(`/packages/provider/${providerId}`, data);
  },

  updatePackage: async (packageId, data) => {
    return apiService.put(`/packages/${packageId}`, data);
  },

  deletePackage: async (packageId) => {
    return apiService.delete(`/packages/${packageId}`);
  },

  reorderPackages: async (providerId, orders) => {
    return apiService.put(`/packages/provider/${providerId}/reorder`, { orders });
  },
};

export default packageService;
